module.exports = __webpack_public_path__ + "static/media/image_51.44297995.png";